import Option from "./interfaces/Option";

export const SCROLL_OFFSET_TOP = -30; //px

export const TEXTAREA_ROWS = 3;

export const UPLOAD_MAX_SIZE = 100 * 1024 * 1024; //100MB
export const UPLOAD_MAX_FILES = 20;
export const UPLOAD_MAX_SIZE_30MB = 30 * 1024 * 1024; //30MB

//small delays for better user experience
export const UPLOAD_MIN_DELAY = 500; //ms
export const MIN_LOADER_DELAY = 500; //ms

export const DATE_FORMAT = "d.M.yyyy";

export const ID_DELIMITER = "__";
export const SCOPE_DELIMITER = "/";

export const FORM_HEAD_ID = "THE_FORM_HEAD";
export const FORM_SUBMIT_ID = "THE_FORM_SUBMIT";

export const CUSTOM_FORMS_FOLDER = "forms";

export const ACCEPTED_FILE_TYPES = ["*"]; //file extensions, for example "txt", to accept anything add *

export const MULTISELECT_LANG: Option[] = [
  { label: "Čeština", value: "cs" },
  { label: "Slovenština", value: "sk" },
  { label: "Maďarština", value: "hu" },
  { label: "Polština", value: "pl" },
  { label: "Ruština", value: "ru" },
  { label: "Angličtina", value: "en" },
  { label: "Francouzština", value: "fr" },
  { label: "Němčina", value: "de" },
  { label: "Španělština", value: "es" },
  { label: "Běloruština", value: "be"},
  { label: "Bulharština", value: "bg"},
  { label: "Dánština", value: "da"},
  { label: "Řečtina", value: "el"},
  { label: "Estonština", value: "et"},
  { label: "Finština", value: "fi"},
  { label: "Chorvatština", value: "hr"},
  { label: "Islandština", value: "is"},
  { label: "Italština", value: "it"},
  { label: "Lucemburština", value: "lb"},
  { label: "Litevština", value: "lt"},
  { label: "Lotyština", value: "lv"},
  { label: "Nizozemština", value: "nl"},
  { label: "Norština", value: "no"},
  { label: "Portugalština", value: "pt"},
  { label: "Rumunština", value: "ro"},
  { label: "Slovinština", value: "sl"},
  { label: "Švédština", value: "sv"},
];

export const MULTISELECT_LANG_ENG :Option[]= [
  { 'label': 'Czech', 'value': 'cs' },
  { 'label': 'Slovak', 'value': 'sk' },
  { 'label': 'Hungarian', 'value': 'hu' },
  { 'label': 'Polish', 'value': 'pl' },
  { 'label': 'Russian', 'value': 'ru' },
  { 'label': 'English', 'value': 'en' },
  { 'label': 'French', 'value': 'fr' },
  { 'label': 'German', 'value': 'de' },
  { 'label': 'Spanish', 'value': 'es' },
  { 'label': 'Belarusian', 'value': 'be' },
  { 'label': 'Bulgarian', 'value': 'bg' },
  { 'label': 'Danish', 'value': 'da' },
  { 'label': 'Greek', 'value': 'el' },
  { 'label': 'Estonian', 'value': 'et' },
  { 'label': 'Finnish', 'value': 'fi' },
  { 'label': 'Croatian', 'value': 'hr' },
  { 'label': 'Icelandic', 'value': 'is' },
  { 'label': 'Italian', 'value': 'it' },
  { 'label': 'Luxembourgish', 'value': 'lb' },
  { 'label': 'Lithuanian', 'value': 'lt' },
  { 'label': 'Latvian', 'value': 'lv' },
  { 'label': 'Dutch', 'value': 'nl' },
  { 'label': 'Norwegian', 'value': 'no' },
  { 'label': 'Portuguese', 'value': 'pt' },
  { 'label': 'Romanian', 'value': 'ro' },
  { 'label': 'Slovenian', 'value': 'sl' },
  { 'label': 'Swedish', 'value': 'sv' }
]

export const STATES: Option[] = [
  { label: "Afgánistán", value: "AFG" },
  { label: "Alandské ostrovy", value: "ALA" },
  { label: "Albánie", value: "ALB" },
  { label: "Alžírsko", value: "DZA" },
  { label: "Americká Samoa", value: "ASM" },
  { label: "Americké Panenské ostr.", value: "VIR" },
  { label: "Andorra", value: "AND" },
  { label: "Angola", value: "AGO" },
  { label: "Anguilla", value: "AIA" },
  { label: "Antarktida", value: "ATA" },
  { label: "Antigua a Barbuda", value: "ATG" },
  { label: "Argentina", value: "ARG" },
  { label: "Arménie", value: "ARM" },
  { label: "Aruba", value: "ABW" },
  { label: "Austrálie", value: "AUS" },
  { label: "Azerbájdžán", value: "AZE" },
  { label: "Bahamy", value: "BHS" },
  { label: "Bahrajn", value: "BHR" },
  { label: "Bangladéš", value: "BGD" },
  { label: "Barbados", value: "BRB" },
  { label: "Belgie", value: "BEL" },
  { label: "Belize", value: "BLZ" },
  { label: "Bělorusko", value: "BLR" },
  { label: "Benin", value: "BEN" },
  { label: "Bermudy", value: "BMU" },
  { label: "Bhútán", value: "BTN" },
  { label: "Bissau", value: "GNB" },
  { label: "Bonaire, Svatý Eustach", value: "BES" },
  { label: "Bosna a Hercegovina", value: "BIH" },
  { label: "Bolívie", value: "BOL" },
  { label: "Botswana", value: "BWA" },
  { label: "Bouvetův ostrov", value: "BVT" },
  { label: "Brazílie", value: "BRA" },
  { label: "Britské indickoocenánské území", value: "IOT" },
  { label: "Britské Panenské ostrovy", value: "VGB" },
  { label: "Brunej", value: "BRN" },
  { label: "Bulharsko", value: "BGR" },
  { label: "Burkina Faso", value: "BFA" },
  { label: "Burundi", value: "BDI" },
  { label: "Čad", value: "TCD" },
  { label: "Caicos", value: "TCA" },
  { label: "Černá Hora", value: "MNE" },
  { label: "Česká republika", value: "CZE" },
  { label: "Čína", value: "CHN" },
  { label: "Cookovy ostrovy", value: "COK" },
  { label: "Curaçao", value: "CUW" },
  { label: "Dánsko", value: "DNK" },
  { label: "Demokratická republika Kongo", value: "COD" },
  { label: "Dominika", value: "DMA" },
  { label: "Dominikánská republika", value: "DOM" },
  { label: "Džibutsko", value: "DJI" },
  { label: "Egypt", value: "EGY" },
  { label: "Ekvádor", value: "ECU" },
  { label: "Eritrea", value: "ERI" },
  { label: "Estonsko", value: "EST" },
  { label: "Etiopie", value: "ETH" },
  { label: "Faerské ostrovy", value: "FRO" },
  { label: "Falklandy", value: "FLK" },
  { label: "Fidži", value: "FJI" },
  { label: "Filipíny", value: "PHL" },
  { label: "Finsko", value: "FIN" },
  { label: "Francie", value: "FRA" },
  { label: "Francouzská jižní území", value: "ATF" },
  { label: "Francouzská Polynésie", value: "PYF" },
  { label: "Fransouzská Guinea", value: "GUF" },
  { label: "Futuna", value: "WLF" },
  { label: "Gabon", value: "GAB" },
  { label: "Gambie", value: "GMB" },
  { label: "Ghana", value: "GHA" },
  { label: "Gibraltar", value: "GIB" },
  { label: "Grenada", value: "GRD" },
  { label: "Grónsko", value: "GRL" },
  { label: "Gruzie", value: "GEO" },
  { label: "Guadeloupe", value: "GLP" },
  { label: "Guernsey", value: "GGY" },
  { label: "Guam", value: "GUM" },
  { label: "Guatemala", value: "GTM" },
  { label: "Guinea", value: "GIN" },
  { label: "Guyana", value: "GUY" },
  { label: "Haiti", value: "HTI" },
  { label: "Heardův ostrovy", value: "HMD" },
  { label: "Honduras", value: "HND" },
  { label: "Hongkong", value: "HKG" },
  { label: "Chile", value: "CHL" },
  { label: "Chorvatsko", value: "HRV" },
  { label: "Indie", value: "IND" },
  { label: "Indonésie", value: "IDN" },
  { label: "Irák", value: "IRQ" },
  { label: "Írán", value: "IRN" },
  { label: "Irsko", value: "IRL" },
  { label: "Island", value: "ISL" },
  { label: "Itálie", value: "ITA" },
  { label: "Izrael", value: "ISR" },
  { label: "Jamajka", value: "JAM" },
  { label: "Japonsko", value: "JPN" },
  { label: "Jemen", value: "YEM" },
  { label: "Jersey", value: "JEY" },
  { label: "Jihoafrická republika", value: "ZAF" },
  { label: "Jižní Georgie a Jižní Sandwichovy ostrovy", value: "SGS" },
  { label: "Jižní Korea", value: "KOR" },
  { label: "Jižní Sudán", value: "SSD" },
  { label: "Jordánsko", value: "JOR" },
  { label: "Kajmanské ostrovy", value: "CYM" },
  { label: "Kambodža", value: "KHM" },
  { label: "Kamerun", value: "CMR" },
  { label: "Kanada", value: "CAN" },
  { label: "Kapverdy", value: "CPV" },
  { label: "Katar", value: "QAT" },
  { label: "Kazachstán", value: "KAZ" },
  { label: "Keňa", value: "KEN" },
  { label: "Kiribati", value: "KIR" },
  { label: "Kokosové (Keelingovy) ostrovy", value: "CCK" },
  { label: "Kolumbie", value: "COL" },
  { label: "Komory", value: "COM" },
  { label: "Kongo", value: "COG" },
  { label: "Korejská lid. dem. republika", value: "PRK" },
  { label: "Kosovo", value: "XXK" },
  { label: "Kostarika", value: "CRI" },
  { label: "Království Lesotho", value: "LSO" },
  { label: "Kuba", value: "CUB" },
  { label: "Kuvajt", value: "KWT" },
  { label: "Kypr", value: "CYP" },
  { label: "Kyrgyzstán", value: "KGZ" },
  { label: "Laos", value: "LAO" },
  { label: "Libanon", value: "LBN" },
  { label: "Libérie", value: "LBR" },
  { label: "Libye", value: "LBY" },
  { label: "Lichtenštejsko", value: "LIE" },
  { label: "Litva", value: "LTU" },
  { label: "Lotyšsko", value: "LVA" },
  { label: "Lucembursko", value: "LUX" },
  { label: "Macao", value: "MAC" },
  { label: "Madagaskar", value: "MDG" },
  { label: "Maďarsko", value: "HUN" },
  { label: "Makedonie", value: "MKD" },
  { label: "Malajsie", value: "MYS" },
  { label: "Malawi", value: "MWI" },
  { label: "Maledivy", value: "MDV" },
  { label: "Mali", value: "MLI" },
  { label: "Malta", value: "MLT" },
  { label: "Marino", value: "SMR" },
  { label: "Maroko", value: "MAR" },
  { label: "Marshallovy ostrovy", value: "MHL" },
  { label: "Martinik", value: "MTQ" },
  { label: "Mauricius", value: "MUS" },
  { label: "Mauritánie", value: "MRT" },
  { label: "Mayotte", value: "MYT" },
  { label: "Menší odlehlé ostrovy USA", value: "UMI" },
  { label: "Mexiko", value: "MEX" },
  { label: "Mikronésie", value: "FSM" },
  { label: "Moldávie", value: "MDA" },
  { label: "Monako", value: "MCO" },
  { label: "Mongolsko", value: "MNG" },
  { label: "Montserrat", value: "MSR" },
  { label: "Mosambik", value: "MOZ" },
  { label: "Myanmar", value: "MMR" },
  { label: "Namibie", value: "NAM" },
  { label: "Nauru", value: "NRU" },
  { label: "Německo", value: "DEU" },
  { label: "Nepál", value: "NPL" },
  { label: "Niger", value: "NER" },
  { label: "Nigérie", value: "NGA" },
  { label: "Nikaragua", value: "NIC" },
  { label: "Niue", value: "NIU" },
  { label: "Nizozemsko", value: "NLD" },
  { label: "Nizozemské Antily", value: "ANT" },
  { label: "Norfolk", value: "NFK" },
  { label: "Norsko", value: "NOR" },
  { label: "Nová Kaledonie", value: "NCL" },
  { label: "Nový Zéland", value: "NZL" },
  { label: "Omán", value: "OMN" },
  { label: "Ostrov Man", value: "IMN" },
  { label: "Ostrovy Severní Mariany", value: "MNP" },
  { label: "ostrovy USA v Tichém océanu", value: "PUS" },
  { label: "Pákistán", value: "PAK" },
  { label: "Palauská republika", value: "PLW" },
  { label: "Palestin", value: "XAB" },
  { label: "Palestinské územní (ok.)", value: "PSE" },
  { label: "Panama", value: "PAN" },
  { label: "Papua Nová Guinea", value: "PNG" },
  { label: "Paraguay", value: "PRY" },
  { label: "Peru", value: "PER" },
  { label: "Pitcairn", value: "PCN" },
  { label: "Polsko", value: "POL" },
  { label: "Popřeží slonoviny", value: "CIV" },
  { label: "Portoriko", value: "PRI" },
  { label: "Portugalsko", value: "PRT" },
  { label: "Rakousko", value: "AUT" },
  { label: "Řecko", value: "GRC" },
  { label: "Réunion", value: "REU" },
  { label: "Rhodézie", value: "RDZ" },
  { label: "Rovníková Guinea", value: "GNQ" },
  { label: "Rumunsko", value: "ROM" },
  { label: "Rusko", value: "RUS" },
  { label: "Rwanda", value: "RWA" },
  { label: "Řád Maltézských rytířů", value: "XMR" },
  { label: "Salvador", value: "SLV" },
  { label: "Samoa", value: "WSM" },
  { label: "Saudská Arábie", value: "SAU" },
  { label: "Senegal", value: "SEN" },
  { label: "Seychely", value: "SYC" },
  { label: "Sierra Leone", value: "SLE" },
  { label: "Singapur", value: "SGP" },
  { label: "Slovensko", value: "SVK" },
  { label: "Slovinsko", value: "SVN" },
  { label: "Somálsko", value: "SOM" },
  { label: "Španělsko", value: "ESP" },
  { label: "Spojené arabské emiráty", value: "ARE" },
  { label: "Srbsko", value: "SRB" },
  { label: "Srí Lanka", value: "LKA" },
  { label: "ST. Saint-Pierre Miquelon", value: "SPM" },
  { label: "Středoafrická republika", value: "CAF" },
  { label: "Súdán", value: "SDN" },
  { label: "Surinam", value: "SUR" },
  { label: "Svalbard a Jan Mayen", value: "SJM" },
  { label: "Sv. Grenadiny", value: "VCT" },
  { label: "Sv. Helena", value: "SHN" },
  { label: "Sv. Lucie", value: "LCA" },
  { label: "Sv. Tomáš Princův ost.", value: "STP" },
  { label: "Sv. Kryštov Nevis", value: "KNA" },
  { label: "Svazijsko", value: "SWZ" },
  { label: "Šalamounovy ostrovy", value: "SLB" },
  { label: "Švédsko", value: "SWE" },
  { label: "Švýcarsko", value: "CHE" },
  { label: "Sýrie", value: "SYR" },
  { label: "Tádžikistán", value: "TJK" },
  { label: "Taiwan", value: "TWN" },
  { label: "Tanzanie", value: "TZA" },
  { label: "Thajsko", value: "THA" },
  { label: "Trinidad a Tobago", value: "TTO" },
  { label: "Togo", value: "TGO" },
  { label: "Tokelau", value: "TKL" },
  { label: "Tonga", value: "TON" },
  { label: "Tunis", value: "TUN" },
  { label: "Turecko", value: "TUR" },
  { label: "Turkmenistán", value: "TKM" },
  { label: "Tuvalu", value: "TUV" },
  { label: "Uganda", value: "UGA" },
  { label: "Ukrajina", value: "UKR" },
  { label: "Uruguay", value: "URY" },
  { label: "USA", value: "USA" },
  { label: "Uzbekistán", value: "UZB" },
  { label: "Vánoční Ostrov", value: "CXR" },
  { label: "Vanuatská (Nové Hebridy)", value: "VUT" },
  { label: "Vatikán", value: "VAT" },
  { label: "Velká Británie", value: "GBR" },
  { label: "Venezuela", value: "VEN" },
  { label: "Vietnam", value: "VNM" },
  { label: "Východní Timor", value: "TMP" },
  { label: "Zaire", value: "ZAR" },
  { label: "Zambie", value: "ZMB" },
  { label: "Západní sahara", value: "ESH" },
  { label: "Země královny Maud", value: "ATN" },
  { label: "Zimbabwe", value: "ZWE" },
];

export const STATES_EU: Option[] = [
  { label: "Belgie", value: "BEL" },
  { label: "Bulharsko", value: "BGR" },
  { label: "Česká Republika", value: "CZE" },
  { label: "Dánsko", value: "DNK" },
  { label: "Estonsko", value: "EST" },
  { label: "Finsko", value: "FIN" },
  { label: "Francie", value: "FRA" },
  { label: "Chorvatsko", value: "HRV" },
  { label: "Irsko", value: "IRL" },
  { label: "Itálie", value: "ITA" },
  { label: "Kypr", value: "CYP" },
  { label: "Litva", value: "LTU" },
  { label: "Lotyšsko", value: "LVA" },
  { label: "Lucembursko", value: "LUX" },
  { label: "Maďarsko", value: "HUN" },
  { label: "Malta", value: "MLT" },
  { label: "Německo", value: "DEU" },
  { label: "Nizozemsko", value: "NLD" },
  { label: "Polsko", value: "POL" },
  { label: "Portugalsko", value: "PRT" },
  { label: "Rakousko", value: "AUT" },
  { label: "Rumunsko", value: "ROM" },
  { label: "Řecko", value: "GRC" },
  { label: "Slovensko", value: "SVK" },
  { label: "Slovinsko", value: "SVN" },
  { label: "Španělsko", value: "ESP" },
  { label: "Švédsko", value: "SWE" },
];

export const STATES_EU_MIN = ['Finsko', 'Irsko', 'Maďarsko', 'Německo', 'Polsko', 'Slovensko','Španělsko']


export const STATES_ENG: Option[] = [
  { label: "Afghanistan", value: "AFG" },
  {
    label: "Aland Island",
    value: "ALA",
  },
  { label: "Albania", value: "ALB" },
  { label: "Algeria", value: "DZA" },
  {
    label: "American Samoa",
    value: "ASM",
  },
  { label: "Virgin Islands (U. S.)", value: "VIR" },
  { label: "Andorra", value: "AND" },
  {
    label: "Angola",
    value: "AGO",
  },
  { label: "Anguilla", value: "AIA" },
  { label: "Antarctica", value: "ATA" },
  {
    label: "Antigua and Barbuda",
    value: "ATG",
  },
  { label: "Argentina", value: "ARG" },
  { label: "Armenia", value: "ARM" },
  {
    label: "Aruba",
    value: "ABW",
  },
  { label: "Australia", value: "AUS" },
  { label: "Azerbaijan", value: "AZE" },
  {
    label: "Bahamas (the)",
    value: "BHS",
  },
  { label: "Bahrain", value: "BHR" },
  { label: "Bangladesh", value: "BGD" },
  {
    label: "Barbados",
    value: "BRB",
  },
  { label: "Belgium", value: "BEL" },
  { label: "Belize", value: "BLZ" },
  {
    label: "Belarus",
    value: "BLR",
  },
  { label: "Benin", value: "BEN" },
  { label: "Bermuda", value: "BMU" },
  {
    label: "Bhutan",
    value: "BTN",
  },
  { label: "Bolivia (Plurinational State of)", value: "BOL" },
  {
    label: "Bonaire, Sint Eustatius and Saba",
    value: "BES",
  },
  { label: "Bosnia and Herzegovina", value: "BIH" },
  { label: "Botswana", value: "BWA" },
  {
    label: "Bouvet Island",
    value: "BVT",
  },
  { label: "Brazil", value: "BRA" },
  {
    label: "British Indian Ocean Territory (the)",
    value: "IOT",
  },
  { label: "Virgin Islands (British)", value: "VGB" },
  { label: "Brunei Darussalam", value: "BRN" },
  {
    label: "Bulgaria",
    value: "BGR",
  },
  { label: "Burkina Faso", value: "BFA" },
  { label: "Burundi", value: "BDI" },
  {
    label: "Cook Islands (the)",
    value: "COK",
  },
  { label: "Curaçao", value: "CUW" },
  { label: "Chad", value: "TCD" },
  {
    label: "Montenegro",
    value: "MNE",
  },
  { label: "Czechia", value: "CZE" },
  { label: "China", value: "CHN" },
  {
    label: "Denmark",
    value: "DNK",
  },
  { label: "Congo (the Democratic Republic of the)", value: "COD" },
  {
    label: "Dominica",
    value: "DMA",
  },
  { label: "Dominican Republic (the)", value: "DOM" },
  { label: "Djibouti", value: "DJI" },
  {
    label: "Egypt",
    value: "EGY",
  },
  { label: "Ecuador", value: "ECU" },
  { label: "Eritrea", value: "ERI" },
  {
    label: "Estonia",
    value: "EST",
  },
  { label: "Ethiopia", value: "ETH" },
  {
    label: "Faroe Islands (the)",
    value: "FRO",
  },
  { label: "Falkland Islands (the) (Malvinas)", value: "FLK" },
  {
    label: "Fiji",
    value: "FJI",
  },
  { label: "Philippines (the)", value: "PHL" },
  { label: "Finland", value: "FIN" },
  {
    label: "France",
    value: "FRA",
  },
  { label: "French Guiana", value: "GUF" },
  {
    label: "French Southern Territories (the)",
    value: "ATF",
  },
  { label: "French Polynesia", value: "PYF" },
  { label: "Gabon", value: "GAB" },
  {
    label: "Gambia (the)",
    value: "GMB",
  },
  { label: "Ghana", value: "GHA" },
  { label: "Gibraltar", value: "GIB" },
  {
    label: "Grenada",
    value: "GRD",
  },
  { label: "Greenland", value: "GRL" },
  { label: "Georgia", value: "GEO" },
  {
    label: "Guadeloupe",
    value: "GLP",
  },
  { label: "Guam", value: "GUM" },
  { label: "Guatemala", value: "GTM" },
  {
    label: "Guernsey",
    value: "GGY",
  },
  { label: "Guinea", value: "GIN" },
  { label: "Guinea-Bissau", value: "GNB" },
  {
    label: "Guyana",
    value: "GUY",
  },
  { label: "Haiti", value: "HTI" },
  { label: "Heard Island and McDonald Islands", value: "HMD" },
  {
    label: "Honduras",
    value: "HND",
  },
  { label: "Hong Kong", value: "HKG" },
  { label: "Chile", value: "CHL" },
  {
    label: "Croatia",
    value: "HRV",
  },
  { label: "India", value: "IND" },
  { label: "Indonesia", value: "IDN" },
  {
    label: "Iraq",
    value: "IRQ",
  },
  { label: "Iran (Islamic Republic of)", value: "IRN" },
  { label: "Ireland", value: "IRL" },
  {
    label: "Iceland",
    value: "ISL",
  },
  { label: "Italy", value: "ITA" },
  { label: "Israel", value: "ISR" },
  { label: "Jamaica", value: "JAM" },
  {
    label: "Japan",
    value: "JPN",
  },
  { label: "Yemen", value: "YEM" },
  { label: "Jersey", value: "JEY" },
  {
    label: "South Africa",
    value: "ZAF",
  },
  { label: "South Georgia and the South Sandwich Islands", value: "SGS" },
  {
    label: "South Sudan",
    value: "SSD",
  },
  { label: "Jordan", value: "JOR" },
  { label: "Cayman Islands (the)", value: "CYM" },
  {
    label: "Cambodia",
    value: "KHM",
  },
  { label: "Cameroon", value: "CMR" },
  { label: "Canada", value: "CAN" },
  {
    label: "Cape Verde",
    value: "CPV",
  },
  { label: "Qatar", value: "QAT" },
  { label: "Kazakhstan", value: "KAZ" },
  {
    label: "Kenya",
    value: "KEN",
  },
  { label: "Kiribati", value: "KIR" },
  { label: "Cocos (Keeling) Islands (the)", value: "CCK" },
  {
    label: "Colombia",
    value: "COL",
  },
  { label: "Comoros (the)", value: "COM" },
  {
    label: "Congo (the)",
    value: "COG",
  },
  { label: "Korea (the Democratic People's Republic of)", value: "PRK" },
  {
    label: "Korea (the Republic of)",
    value: "KOR",
  },
  { label: "Kosovo", value: "XXK" },
  { label: "Costa Rica", value: "CRI" },
  { label: "Cuba", value: "CUB" },
  {
    label: "Kuwait",
    value: "KWT",
  },
  { label: "Cyprus", value: "CYP" },
  {
    label: "Kyrgyzstan",
    value: "KGZ",
  },
  { label: "Lao People's Democratic Republic (the)", value: "LAO" },
  {
    label: "Lesotho",
    value: "LSO",
  },
  { label: "Lebanon", value: "LBN" },
  { label: "Liberia", value: "LBR" },
  {
    label: "Libya",
    value: "LBY",
  },
  { label: "Liechtenstein", value: "LIE" },
  { label: "Lithuania", value: "LTU" },
  {
    label: "Latvia",
    value: "LVA",
  },
  { label: "Luxembourg", value: "LUX" },
  { label: "Macao", value: "MAC" },
  {
    label: "Madagascar",
    value: "MDG",
  },
  { label: "Hungary", value: "HUN" },
  { label: "North Macedonia", value: "MKD" },
  {
    label: "Malaysia",
    value: "MYS",
  },
  { label: "Malawi", value: "MWI" },
  { label: "Maldives", value: "MDV" },
  { label: "Mali", value: "MLI" },
  {
    label: "Malta",
    value: "MLT",
  },
  { label: "Isle of Man", value: "IMN" },
  { label: "Morocco", value: "MAR" },
  {
    label: "Marshall Islands (the)",
    value: "MHL",
  },
  { label: "Martinique", value: "MTQ" },
  { label: "Mauritius", value: "MUS" },
  {
    label: "Mauritania",
    value: "MRT",
  },
  { label: "Mayotte", value: "MYT" },
  {
    label: "United States Minor Outlying Islands (the)",
    value: "UMI",
  },
  { label: "Mexico", value: "MEX" },
  {
    label: "Micronesia (Federated States of)",
    value: "FSM",
  },
  { label: "Moldova (the Republic of)", value: "MDA" },
  { label: "Monaco", value: "MCO" },
  {
    label: "Mongolia",
    value: "MNG",
  },
  { label: "Montserrat", value: "MSR" },
  { label: "Mozambique", value: "MOZ" },
  {
    label: "Myanmar",
    value: "MMR",
  },
  { label: "Namibia", value: "NAM" },
  { label: "Nauru", value: "NRU" },
  {
    label: "Germany",
    value: "DEU",
  },
  { label: "Nepal", value: "NPL" },
  { label: "Niger (the)", value: "NER" },
  {
    label: "Nigeria",
    value: "NGA",
  },
  { label: "Nicaragua", value: "NIC" },
  { label: "Niue", value: "NIU" },
  {
    label: "Netherlands (the)",
    value: "NLD",
  },
  { label: "Norfolk Island", value: "NFK" },
  { label: "Norway", value: "NOR" },
  {
    label: "New Caledonia",
    value: "NCL",
  },
  { label: "New Zealand", value: "NZL" },
  { label: "Oman", value: "OMN" },
  {
    label: "Pakistan",
    value: "PAK",
  },
  { label: "Palau", value: "PLW" },
  { label: "Palestine, State of", value: "PSE" },
  {
    label: "Panama",
    value: "PAN",
  },
  { label: "Papua New Guinea", value: "PNG" },
  { label: "Paraguay", value: "PRY" },
  {
    label: "Peru",
    value: "PER",
  },
  { label: "Pitcairn", value: "PCN" },
  { label: "Côte d'Ivoire", value: "CIV" },
  {
    label: "Poland",
    value: "POL",
  },
  { label: "Puerto Rico", value: "PRI" },
  { label: "Portugal", value: "PRT" },
  {
    label: "Austria",
    value: "AUT",
  },
  { label: "Réunion", value: "REU" },
  { label: "Equatorial Guinea", value: "GNQ" },
  {
    label: "Romania",
    value: "ROU",
  },
  { label: "Russian Federation (the)", value: "RUS" },
  { label: "Rwanda", value: "RWA" },
  {
    label: "Greece",
    value: "GRC",
  },
  { label: "Saint Pierre and Miquelon", value: "SPM" },
  { label: "El Salvador", value: "SLV" },
  {
    label: "Samoa",
    value: "WSM",
  },
  { label: "San Marino", value: "SMR" },
  { label: "Saudi Arabia", value: "SAU" },
  {
    label: "Senegal",
    value: "SEN",
  },
  { label: "Northern Mariana Islands (the)", value: "MNP" },
  {
    label: "Seychelles",
    value: "SYC",
  },
  { label: "Sierra Leone", value: "SLE" },
  { label: "Singapore", value: "SGP" },
  {
    label: "Slovakia",
    value: "SVK",
  },
  { label: "Slovenia", value: "SVN" },
  { label: "Somalia", value: "SOM" },
  {
    label: "United Arab Emirates (the)",
    value: "ARE",
  },
  { label: "United States of America (the)", value: "USA" },
  {
    label: "Serbia",
    value: "SRB",
  },
  { label: "Central African Republic (the)", value: "CAF" },
  { label: "Sudan (the)", value: "SDN" },
  {
    label: "Suriname",
    value: "SUR",
  },
  { label: "Saint Helena, Ascension and Tristan da Cunha", value: "SHN" },
  {
    label: "Saint Lucia",
    value: "LCA",
  },
  { label: "Saint Barthélemy", value: "BLM" },
  {
    label: "Saint Kitts and Nevis",
    value: "KNA",
  },
  { label: "Saint Martin (French part)", value: "MAF" },
  {
    label: "Sint Maarten (Dutch part)",
    value: "SXM",
  },
  { label: "Sao Tome and Principe", value: "STP" },
  {
    label: "Saint Vincent and the Grenadines",
    value: "VCT",
  },
  { label: "Eswatini", value: "SWZ" },
  { label: "Syrian Arab Republic", value: "SYR" },
  {
    label: "Solomon Islands",
    value: "SLB",
  },
  { label: "Spain", value: "ESP" },
  { label: "Svalbard and Jan Mayen", value: "SJM" },
  {
    label: "Sri Lanka",
    value: "LKA",
  },
  { label: "Sweden", value: "SWE" },
  { label: "Switzerland", value: "CHE" },
  {
    label: "Tajikistan",
    value: "TJK",
  },
  { label: "Tanzania, United Republic of", value: "TZA" },
  {
    label: "Thailand",
    value: "THA",
  },
  { label: "Taiwan (Province of China)", value: "TWN" },
  { label: "Togo", value: "TGO" },
  {
    label: "Tokelau",
    value: "TKL",
  },
  { label: "Tonga", value: "TON" },
  { label: "Trinidad and Tobago", value: "TTO" },
  {
    label: "Tunisia",
    value: "TUN",
  },
  { label: "Turkey", value: "TUR" },
  { label: "Turkmenistan", value: "TKM" },
  {
    label: "Turks and Caicos Islands (the)",
    value: "TCA",
  },
  { label: "Tuvalu", value: "TUV" },
  { label: "Uganda", value: "UGA" },
  {
    label: "Ukraine",
    value: "UKR",
  },
  { label: "Uruguay", value: "URY" },
  { label: "Uzbekistan", value: "UZB" },
  {
    label: "Christmas Island",
    value: "CXR",
  },
  { label: "Vanuatu", value: "VUT" },
  {
    label: "Holy See (the)",
    value: "VAT",
  },
  {
    label: "United Kingdom of Great Britain and Northern Ireland (the)",
    value: "GBR",
  },
  { label: "Venezuela (Bolivarian Republic of)", value: "VEN" },
  {
    label: "Viet Nam",
    value: "VNM",
  },
  { label: "Timor-Leste", value: "TLS" },
  { label: "Wallis and Futuna", value: "WLF" },
  {
    label: "Zambia",
    value: "ZMB",
  },
  { label: "Western Sahara", value: "ESH" },
  { label: "Zimbabwe", value: "ZWE" },
].sort((a,b)=>a.label.localeCompare(b.label));

const STATES_2CHAR = {
  'FR': 'Francie',
  'NL': 'Nizozemsko',
  'DE': 'Německo',
  'IT': 'Itálie',
  'GB': 'Spojené království',
  'IE': 'Irsko',
  'DK': 'Dánsko',
  'GR': 'Řecko',
  'PT': 'Portugalsko',
  'ES': 'Španělsko',
  'BE': 'Belgie',
  'LU': 'Lucembursko',
  'XC': 'Ceuta',
  'XL': 'Melilla',
  'IS': 'Island',
  'NO': 'Norsko',
  'SE': 'Švédsko',
  'FI': 'Finsko',
  'LI': 'Lichtenštejnsko',
  'AT': 'Rakousko',
  'CH': 'Švýcarsko',
  'FO': 'Faerské ostrovy',
  'AD': 'Andorra',
  'GI': 'Gibraltar',
  'VA': 'Svatý stolec',
  'MT': 'Malta',
  'SM': 'San Marino',
  'TR': 'Turecko',
  'EE': 'Estonsko',
  'LV': 'Lotyšsko',
  'LT': 'Litva',
  'PL': 'Polsko',
  'CZ': 'Česká republika',
  'SK': 'Slovensko',
  'HU': 'Maďarsko',
  'RO': 'Rumunsko',
  'BG': 'Bulharsko',
  'AL': 'Albánie',
  'UA': 'Ukrajina',
  'BY': 'Bělorusko',
  'MD': 'Moldavsko',
  'RU': 'Rusko',
  'GE': 'Gruzie',
  'AM': 'Arménie',
  'AZ': 'Ázerbájdžán',
  'KZ': 'Kazachstán',
  'TM': 'Turkmenistán',
  'UZ': 'Uzbekistán',
  'TJ': 'Tádžikistán',
  'KG': 'Kyrgyzstán',
  'SI': 'Slovinsko',
  'HR': 'Chorvatsko',
  'BA': 'Bosna a Hercegovina',
  'YU': 'Jugoslávie',
  'MK': 'Makedonie',
  'MA': 'Maroko',
  'DZ': 'Alžírsko',
  'TN': 'Tunisko',
  'LY': 'Libye',
  'EG': 'Egypt',
  'SD': 'Súdán',
  'MR': 'Mauritánie',
  'ML': 'Mali',
  'BF': 'Burkina Faso',
  'NE': 'Niger',
  'TD': 'Čad',
  'CV': 'Kapverdy',
  'SN': 'Senegal',
  'GM': 'Gambie',
  'GW': 'Guinea-Bissau',
  'GN': 'Guinea',
  'SL': 'Sierra Leone',
  'LR': 'Libérie',
  'CI': 'Pobřeží slonoviny',
  'GH': 'Ghana',
  'TG': 'Togo',
  'BJ': 'Benin',
  'NG': 'Nigérie',
  'CM': 'Kamerun',
  'CF': 'Středoafrická republika',
  'GQ': 'Rovníková Guinea',
  'ST': 'Svatý Tomáš',
  'GA': 'Gabon',
  'CG': 'Kongo',
  'CD': 'Kongo, demokratická republika',
  'RW': 'Rwanda',
  'BI': 'Burundi',
  'SH': 'Svatá Helena',
  'AO': 'Angola',
  'ET': 'Etiopie',
  'ER': 'Eritrea',
  'DJ': 'Džibutsko',
  'SO': 'Somálsko',
  'KE': 'Keňa',
  'UG': 'Uganda',
  'TZ': 'Tanzanie',
  'SC': 'Seychely',
  'IO': 'Britské indickooceánské území',
  'MZ': 'Mosambik',
  'MG': 'Madagaskar',
  'MU': 'Mauricius',
  'KM': 'Komory',
  'YT': 'Mayotte',
  'ZM': 'Zambie',
  'ZW': 'Zimbabwe',
  'MW': 'Malawi',
  'ZA': 'Jihoafrická republika',
  'NA': 'Namibie',
  'BW': 'Botswana',
  'SZ': 'Svazijsko',
  'LS': 'Lesotho',
  'US': 'Spojené státy',
  'CA': 'Kanada',
  'GL': 'Grónsko',
  'PM': 'Saint Pierre a Miquelon',
  'MX': 'Mexiko',
  'BM': 'Bermudy',
  'GT': 'Guatemala',
  'BZ': 'Belize',
  'HN': 'Honduras',
  'SV': 'Salvador',
  'NI': 'Nikaragua',
  'CR': 'Kostarika',
  'PA': 'Panama',
  'AI': 'Anguilla',
  'CU': 'Kuba',
  'KN': 'Svatý Kryštof a Nevis',
  'HT': 'Haiti',
  'BS': 'Bahamy',
  'TC': 'Turks a Caicos',
  'DO': 'Dominikánská republika',
  'VI': 'Americké Panenské ostrovy',
  'AG': 'Antigua a Barbuda',
  'DM': 'Dominika',
  'KY': 'Kajmanské ostrovy',
  'JM': 'Jamajka',
  'LC': 'Svatá Lucie',
  'VC': 'Svatý Vincenc a Grenadiny',
  'VG': 'Britské Panenské ostrovy',
  'BB': 'Barbados',
  'MS': 'Montserrat',
  'TT': 'Trinidad a Tobago',
  'GD': 'Grenada',
  'AW': 'Aruba',
  'AN': 'Nizozemské Antily',
  'CO': 'Kolumbie',
  'VE': 'Venezuela',
  'GY': 'Guyana',
  'SR': 'Surinam',
  'EC': 'Ekvádor',
  'PE': 'Peru',
  'BR': 'Brazílie',
  'CL': 'Chile',
  'BO': 'Bolívie',
  'PY': 'Paraguay',
  'UY': 'Uruguay',
  'AR': 'Argentina',
  'FK': 'Falklandy',
  'CY': 'Kypr',
  'LB': 'Libanon',
  'SY': 'Sýrie',
  'IQ': 'Irák',
  'IR': 'Írán',
  'IL': 'Izrael',
  'PS': 'Okupované palestinské území',
  'TP': 'Východní Timor',
  'JO': 'Jordánsko',
  'SA': 'Saúdská Arábie',
  'KW': 'Kuvajt',
  'BH': 'Bahrajn',
  'QA': 'Katar',
  'AE': 'Spojené arabské emiráty',
  'OM': 'Omán',
  'YE': 'Jemen',
  'AF': 'Afghánistán',
  'PK': 'Pákistán',
  'IN': 'Indie',
  'BD': 'Bangladéš',
  'MV': 'Maledivy',
  'LK': 'Srí Lanka',
  'NP': 'Nepál',
  'BT': 'Bhútán',
  'MM': 'Myanmar',
  'TH': 'Thajsko',
  'LA': 'Laos',
  'VN': 'Vietnam',
  'KH': 'Kambodža',
  'ID': 'Indonésie',
  'MY': 'Malajsie',
  'BN': 'Brunej Darussalam',
  'SG': 'Singapur',
  'PH': 'Filipíny',
  'MN': 'Mongolsko',
  'CN': 'Čína',
  'KP': 'Korea, lidově demokratická republika',
  'KR': 'Korea',
  'JP': 'Japonsko',
  'TW': 'Tchaj-wan',
  'HK': 'Hongkong',
  'MO': 'Macao',
  'AU': 'Austrálie',
  'PG': 'Papua Nová Guinea',
  'NR': 'Nauru',
  'NZ': 'Nový Zéland',
  'SB': 'Šalamounovy ostrovy',
  'TV': 'Tuvalu',
  'NC': 'Nová Kaledonie',
  'WF': 'Wallis a Futuna',
  'KI': 'Kiribati',
  'PN': 'Pitcairn',
  'FJ': 'Fidži',
  'VU': 'Vanuatu',
  'TO': 'Tonga',
  'WS': 'Samoa',
  'MP': 'Severní Mariany',
  'PF': 'Francouzská Polynésie',
  'FM': 'Mikronésie',
  'MH': 'Marshallovy ostrovy',
  'PW': 'Palau',
  'AS': 'Americká Samoa',
  'GU': 'Guam',
  'UM': 'Menší odlehlé ostrovy USA',
  'CC': 'Kokosové ostrovy',
  'CX': 'Vánoční ostrov',
  'HM': 'Heardův ostrov a McDonaldovy ostrovy',
  'NF': 'Norfolk',
  'CK': 'Cookovy ostrovy',
  'NU': 'Niue',
  'TK': 'Tokelau',
  'AQ': 'Antarktida',
  'BV': 'Bouvetův ostrov',
  'GS': 'Jižní Georgie a Jižní Sandwichovy ostrovy',
  'TF': 'Francouzská jižní území',
}

const STATES_2CHAR_EN = {
  'FR': 'France',
  'NL': 'Netherlands',
  'DE': 'Germany',
  'IT': 'Italy',
  'GB': 'United Kingdom',
  'IE': 'Ireland',
  'DK': 'Denmark',
  'GR': 'Greece',
  'PT': 'Portugal',
  'ES': 'Spain',
  'BE': 'Belgium',
  'LU': 'Luxembourg',
  'XC': 'Ceuta',
  'XL': 'Melilla',
  'IS': 'Iceland',
  'NO': 'Norway',
  'SE': 'Sweden',
  'FI': 'Finland',
  'LI': 'Liechtenstein',
  'AT': 'Austria',
  'CH': 'Switzerland',
  'FO': 'Faeroe Islands',
  'AD': 'Andorra',
  'GI': 'Gibraltar',
  'VA': 'Holy See',
  'MT': 'Malta',
  'SM': 'San Marino',
  'TR': 'Turkey',
  'EE': 'Estonia',
  'LV': 'Latvia',
  'LT': 'Lithuania',
  'PL': 'Poland',
  'CZ': 'Czech Republic',
  'SK': 'Slovakia',
  'HU': 'Hungary',
  'RO': 'Romania',
  'BG': 'Bulgaria',
  'AL': 'Albania',
  'UA': 'Ukraine',
  'BY': 'Belarus',
  'MD': 'Moldova (Republic of)',
  'RU': 'Russian Federation',
  'GE': 'Georgia',
  'AM': 'Armenia',
  'AZ': 'Azerbaijan',
  'KZ': 'Kazakhstan',
  'TM': 'Turkmenistan',
  'UZ': 'Uzbekistan',
  'TJ': 'Tajikistan',
  'KG': 'Kyrgyzstan',
  'SI': 'Slovenia',
  'HR': 'Croatia',
  'BA': 'Bosnia - Herzegovina',
  'YU': 'Yugoslavia',
  'MK': 'Former Yugoslav Republic of Macedonia',
  'MA': 'Morocco',
  'DZ': 'Algeria',
  'TN': 'Tunisia',
  'LY': 'Libyan Arab Jamahiriya',
  'EG': 'Egypt',
  'SD': 'Sudan',
  'MR': 'Mauritania',
  'ML': 'Mali',
  'BF': 'Burkina Faso',
  'NE': 'Niger',
  'TD': 'Chad',
  'CV': 'Cape Verde',
  'SN': 'Senegal',
  'GM': 'Gambia',
  'GW': 'Guinea-Bissau',
  'GN': 'Guinea',
  'SL': 'Sierra Leone',
  'LR': 'Liberia',
  'CI': 'Côte ďIvoire',
  'GH': 'Ghana',
  'TG': 'Togo',
  'BJ': 'Benin',
  'NG': 'Nigeria',
  'CM': 'Cameroon',
  'CF': 'Central African Republic',
  'GQ': 'Equatorial Guinea',
  'ST': 'Sao Tome and Principe',
  'GA': 'Gabon',
  'CG': 'Congo',
  'CD': 'Congo (Democratic Republic of)',
  'RW': 'Rwanda',
  'BI': 'Burundi',
  'SH': 'St Helena',
  'AO': 'Angola',
  'ET': 'Ethiopia',
  'ER': 'Eritrea',
  'DJ': 'Djibouti',
  'SO': 'Somalia',
  'KE': 'Kenya',
  'UG': 'Uganda',
  'TZ': 'Tanzania (United Republic of)',
  'SC': 'Seychelles',
  'IO': 'British Indian Ocean Territory',
  'MZ': 'Mozambique',
  'MG': 'Madagascar',
  'MU': 'Mauritius',
  'KM': 'Comoros',
  'YT': 'Mayotte',
  'ZM': 'Zambia',
  'ZW': 'Zimbabwe',
  'MW': 'Malawi',
  'ZA': 'South Africa',
  'NA': 'Namibia',
  'BW': 'Botswana',
  'SZ': 'Swaziland',
  'LS': 'Lesotho',
  'US': 'United States',
  'CA': 'Canada',
  'GL': 'Greenland',
  'PM': 'St Pierre and Miquelon',
  'MX': 'Mexico',
  'BM': 'Bermuda',
  'GT': 'Guatemala',
  'BZ': 'Belize',
  'HN': 'Honduras',
  'SV': 'El Salvador',
  'NI': 'Nicaragua',
  'CR': 'Costa Rica',
  'PA': 'Panama',
  'AI': 'Anguilla',
  'CU': 'Cuba',
  'KN': 'St Kitts and Nevis',
  'HT': 'Haiti',
  'BS': 'Bahamas',
  'TC': 'Turks and Caicos Islands',
  'DO': 'Dominican Republic',
  'VI': 'Virgin Islands (U.S.)',
  'AG': 'Antigua and Barbuda',
  'DM': 'Dominica',
  'KY': 'Cayman Islands',
  'JM': 'Jamaica',
  'LC': 'St Lucia',
  'VC': 'St Vincent and the Grenadines',
  'VG': 'Virgin Islands (British)',
  'BB': 'Barbados',
  'MS': 'Montserrat',
  'TT': 'Trinidad and Tobago',
  'GD': 'Grenada',
  'AW': 'Aruba',
  'AN': 'Netherlands Antilles',
  'CO': 'Colombia',
  'VE': 'Venezuela',
  'GY': 'Guyana',
  'SR': 'Suriname',
  'EC': 'Ecuador',
  'PE': 'Peru',
  'BR': 'Brazil',
  'CL': 'Chile',
  'BO': 'Bolivia',
  'PY': 'Paraguay',
  'UY': 'Uruguay',
  'AR': 'Argentina',
  'FK': 'Falkland Islands',
  'CY': 'Cyprus',
  'LB': 'Lebanon',
  'SY': 'Syrian Arab Republic',
  'IQ': 'Iraq',
  'IR': 'Iran (Islamic Republic of)',
  'IL': 'Israel',
  'PS': 'Occupied Palestinian Territory',
  'TP': 'East Timor',
  'JO': 'Jordan',
  'SA': 'Saudi Arabia',
  'KW': 'Kuwait',
  'BH': 'Bahrain',
  'QA': 'Qatar',
  'AE': 'United Arab Emirates',
  'OM': 'Oman',
  'YE': 'Yemen',
  'AF': 'Afghanistan',
  'PK': 'Pakistan',
  'IN': 'India',
  'BD': 'Bangladesh',
  'MV': 'Maldives',
  'LK': 'Sri Lanka',
  'NP': 'Nepal',
  'BT': 'Bhutan',
  'MM': 'Myanmar',
  'TH': 'Thailand',
  'LA': 'Lao (People’ s Democratic Republic of)',
  'VN': 'Viet Nam',
  'KH': 'Cambodia',
  'ID': 'Indonesia',
  'MY': 'Malaysia',
  'BN': 'Brunei Darussalam',
  'SG': 'Singapore',
  'PH': 'Philippines',
  'MN': 'Mongolia',
  'CN': 'China (People’ s Republic of)',
  'KP': 'Korea (Democratic People’ s Republic of)',
  'KR': 'Korea (Republic of)',
  'JP': 'Japan',
  'TW': 'Taiwan',
  'HK': 'Hong Kong',
  'MO': 'Macao',
  'AU': 'Australia',
  'PG': 'Papua New Guinea',
  'NR': 'Nauru',
  'NZ': 'New Zealand',
  'SB': 'Solomon Islands',
  'TV': 'Tuvalu',
  'NC': 'New Caledonia',
  'WF': 'Wallis and Futuna',
  'KI': 'Kiribati',
  'PN': 'Pitcairn',
  'FJ': 'Fiji',
  'VU': 'Vanuatu',
  'TO': 'Tonga',
  'WS': 'Samoa',
  'MP': 'Northern Mariana Islands',
  'PF': 'French Polynesia',
  'FM': 'Micronesia (Federated States of)',
  'MH': 'Marshall Islands',
  'PW': 'Palau',
  'AS': 'American Samoa',
  'GU': 'Guam',
  'UM': 'United States Minor Outlying Islands',
  'CC': 'Cocos Islands',
  'CX': 'Christmas Island',
  'HM': 'Heard Island and McDonald Islands',
  'NF': 'Norfolk Island',
  'CK': 'Cook Islands',
  'NU': 'Niue Island',
  'TK': 'Tokelau Islands',
  'AQ': 'Antarctica',
  'BV': 'Bouvet Island',
  'GS': 'South Georgia and South Sandwich Islands',
  'TF': 'French Southern Territories',
}

export const optionsStates2char = Object.entries(STATES_2CHAR).map(([ value, label]) => ({
  label: label,
  value: value
})).sort((a, b) => a.label.localeCompare(b.label))
export const optionsStates2charEn = Object.entries(STATES_2CHAR_EN).map(([value, label]) => ({
  label: label,
  value: value
})).sort((a, b) => a.label.localeCompare(b.label))
